<template>
    <div class="user-account">
        <user-info />
        <account-info />
        <billing-info v-if="user.pro" />
        <update-password />
    </div>
</template>

<script>
import AccountInfo from '@/components/Dashboard/Settings/Account/AccountInfo.vue';
import UserInfo from '@/components/Dashboard/Settings/Account/UserInfo.vue';
import UpdatePassword from '@/components/Dashboard/Settings/Account/UpdatePassword.vue';
import BillingInfo from '@/components/Dashboard/Settings/Account/BillingInfo.vue';

import { mapState } from 'vuex';

export default {
    components: {
        AccountInfo,
        UserInfo,
        UpdatePassword,
        BillingInfo,
    },

    computed: {
        ...mapState(['user']),
    },
};
</script>
